export const fontWeight = {
    b1: '400',
    b2: '500',
    b3: '600',
};